import React from 'react';

interface CardProps {
	children: React.ReactNode;
	className?: string;
}

export const Card = ({ children, className = '' }: CardProps) => {
	return (
		<div
			className={`bg-white rounded-2xl shadow-lg border border-gray-100 overflow-visible mb-6 transition-all 
      hover:shadow-xl hover:border-blue-50 ${className}`}
		>
			{children}
		</div>
	);
};

interface CardContentProps {
	children: React.ReactNode;
	className?: string;
}

export const CardContent = ({ children, className = '' }: CardContentProps) => {
	return <div className={`p-6 md:p-8 ${className}`}>{children}</div>;
};

interface CardHeaderProps {
	title: string;
	description?: string;
	className?: string;
}

export const CardHeader = ({ title, description, className = '' }: CardHeaderProps) => {
	return (
		<div className={`px-6 pt-6 md:px-8 md:pt-8 pb-4 ${className}`}>
			<h2 className="text-xl font-semibold text-gray-800">{title}</h2>
			{description && <p className="mt-1 text-sm text-gray-500">{description}</p>}
		</div>
	);
};

interface CardFooterProps {
	children: React.ReactNode;
	className?: string;
}

export const CardFooter = ({ children, className = '' }: CardFooterProps) => {
	return (
		<div
			className={`flex justify-between items-center p-4 md:p-6 bg-gray-50 border-t border-gray-100 ${className}`}
		>
			{children}
		</div>
	);
};
